<div class="row mx-0" *ngIf="examData?.showQuestionList">
  <div class="card">
    <div class="card-header bg-transparent" style="text-align: center;">
      <h2 class="mb-0 que-list">{{language.questionList}}</h2>
      <div class="ques_status">
        <div class="col-sm-8 col-sm-4 mx-auto center-status">
          <div class="row">
            <div class="col-sm-6 ques_status_item">
              <h4><span class="mx-2">{{language.answeredQuestions}}</span></h4>
              <button class="badge-answered"></button>
            </div>
            <div class="col-sm-6 ques_status_item">
              <h4><span class="mx-2">{{language.unansweredQuestions}}</span></h4>
              <button class=" badge-unanswered">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="qlistfont"><span><a href="javascript:void(0)" (click)="goBack()" class="return-link"><strong>&lt;&lt;
              {{language.goBack}} </strong></a></span></div>
    </div>
    <div class=" card-body overflow-auto">
      <div class="col-sm-12 " *ngFor="let group  of groupedQuestionsArray">
        <div class="each-que">
          <h5 class="text-muted" *ngIf="group.category && group.category!=''">{{language.category}}: {{group.category}}
          </h5>
          <div class="row mb-2" *ngFor="let question of group.questionList">
            <div class="col-sm-12 col-md-12 col-lg-2 mx-0 que-box d-flex justify-content-center" [ngClass]="{
    'badge-answered': question.examQuestion.answered,
    'badge-unanswered': !question.examQuestion.answered
  }">
              <a class="colorblack box-link w-100 position-relative"
                (click)="gotoquestion(question.examQuestion.questionno)">
                <button type="button"
                  class="qdivs d-flex flex-column align-items-center justify-content-center w-100 text-center"
                  [ngClass]="{
        'badge-answered': question.examQuestion.answered,
        'badge-unanswered': !question.examQuestion.answered
      }">
                  <i class="ni mb-1" [ngClass]="{
          'ni-tag': question.examQuestion.answered,
          'ni-bell-55': !question.examQuestion.answered
        }"></i>
                  <span class="question-label">{{ language.question }}</span>
                  <strong class="question-number">
                    {{ question.examQuestion.questionno }}
                  </strong>
                </button>
                <span *ngIf="question.examQuestion.compulsory" class="compulsory-badge position-absolute">
                  {{ language.compulsoryQuestion }}
                </span>
              </a>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-10 m-0 pt-2 h2 qlistfont question-content"
              style="max-width: 100% !important;">
              <a class="colorblack" (click)="gotoquestion(question.examQuestion.questionno)">
                <div *ngIf="this.examData && this.examData.showQuestionList" class="qdivs"
                  [innerHTML]="question.examQuestion.questionhtml"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
